import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd, NavigationStart, ActivatedRoute } from "@angular/router";
import { RequestService } from "../../request.service";
import { MessageService } from "primeng/components/common/messageservice";
import { TypesService } from "../../../common/types.service";
import { DeleteRequest } from "@models/requests";

@Component({
    templateUrl: "./delete-review.component.html"
})

export class DeleteReviewComponent implements OnInit {
    public id: number;
    public model: DeleteRequest;

    public confirmApproveVisible: boolean = false;
    public confirmDenyVisible: boolean = false;


    constructor(private requestService: RequestService,
        private route: ActivatedRoute,
        private messageService: MessageService,
        private router: Router) { }

    ngOnInit(): void {
        this.id = +this.route.snapshot.params["id"];
        this.getData();
    }


    getData(): void {
        this.requestService.getDeleteRequestForReview(this.id).subscribe(response => this.model = response);
    }

    confirmApprove(): void {
        this.requestService.approveDelete(this.id, this.model).subscribe(
            response => {
                this.confirmApproveVisible = false;
                this.messageService.add({ severity: "success", summary: "Success", detail: response.message });
                setTimeout(() => this.router.navigate(["/requests"]));
            },
            error => {
                this.messageService.add({
                    severity: "error",
                    summary: "An Error Occurred",
                    detail: "An error occurred while attempting to approve this request. Please try again."
                });
            }
        )
    }

    confirmDeny(): void {
        this.requestService.denyRequest(this.id).subscribe(
            response => {
                this.confirmDenyVisible = false;
                this.messageService.add({ severity: "success", summary: "Success", detail: response.message });
                setTimeout(() => this.router.navigate(["/requests"]));
            },
            error => {
                this.messageService.add({
                    severity: "error",
                    summary: "An Error Occurred",
                    detail: "An error occurred while attempting to deny this request. Please try again."
                });
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/requests/review/delete/delete-review.component.ts